import { render, staticRenderFns } from "./TemplateManage.vue?vue&type=template&id=40a5c5ad&scoped=true"
import script from "./TemplateManage.vue?vue&type=script&lang=js"
export * from "./TemplateManage.vue?vue&type=script&lang=js"
import style0 from "./TemplateManage.vue?vue&type=style&index=0&id=40a5c5ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a5c5ad",
  null
  
)

export default component.exports